class SizeGuide extends HTMLElement {
  constructor(){
    super();

    this.unitSlider = this.querySelector('input[type="checkbox"]');
    this.unitSlider.addEventListener('change', (e) => {
      this.convertUnit();
    });
  }

  convertUnit() {
    const unitElems = this.querySelectorAll('[data-convert] [data-cm]');
    const isNumber = (n) => !isNaN(parseFloat(n)) && !isNaN(n - 0);

    unitElems.forEach((el) => {
      if (!isNumber(el.dataset.cm)) return;
      el.innerText = this.dataset.unit === 'cm' ? Math.round(parseInt(el.innerText) / 2.54) : el.dataset.cm;
    });

    this.dataset.unit = this.dataset.unit === 'cm' ? 'inches' : 'cm';
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide);
}